import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api';

class UserService {
  // Felhasználói profil lekérése
  async getProfile() {
    try {
      const response = await apiService.get(API_ENDPOINTS.USERS.PROFILE);
      return response;
    } catch (error) {
      console.error('Profil lekérése hiba:', error);
      throw error;
    }
  }

  // Felhasználói profil frissítése
  async updateProfile(profileData) {
    try {
      const response = await apiService.put(API_ENDPOINTS.USERS.PROFILE, profileData);
      return response;
    } catch (error) {
      console.error('Profil frissítése hiba:', error);
      throw error;
    }
  }

  // Jelszó változtatása
  async changePassword(passwordData) {
    try {
      const response = await apiService.put(API_ENDPOINTS.USERS.PASSWORD, passwordData);
      return response;
    } catch (error) {
      console.error('Jelszó változtatása hiba:', error);
      throw error;
    }
  }

  // MÓDOSÍTVA: ÚJ FÜGGVÉNY AZ AVATAR URL FRISSÍTÉSÉHEZ
  /**
   * Felhasználói avatar URL frissítése.
   * @param {string | null} avatarUrl - Az új avatar URL-je, vagy null a törléshez.
   * @returns {Promise<object>} A backend válasza.
   */
  async updateUserAvatar(avatarUrl) {
    try {
      // A backend endpointja: PUT /api/users/profile/avatar
      const response = await apiService.put('/users/profile/avatar', { avatarUrl });
      return response;
    } catch (error) {
      console.error('Error updating user avatar:', error);
      throw error;
    }
  }

  // TÖRÖLVE: A régi uploadAvatar függvény már nem szükséges,
  // mert az ImageUploader az uploadService-t hívja.
  /*
  async uploadAvatar(file) {
    try {
      console.log('🔄 Frontend: Avatar upload started');
      console.log('📁 File:', file);
      
      const formData = new FormData();
      formData.append('avatar', file);

      console.log('📋 FormData entries:');
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }

      const response = await apiService.post('/users/avatar', formData);
      console.log('✅ Upload response:', response);
      return response;
    } catch (error) {
      console.error('❌ Avatar feltöltése hiba:', error);
      throw error;
    }
  }
  */

  // TÖRÖLVE: A régi deleteAvatar függvény már nem szükséges,
  // mert az updateUserAvatar null értékkel kezeli a törlést.
  /*
  async deleteAvatar() {
    try {
      const response = await apiService.delete(API_ENDPOINTS.USERS.AVATAR);
      return response;
    } catch (error) {
      console.error('Avatar törlése hiba:', error);
      throw error;
    }
  }
  */

  // Felhasználó törlése
  async deleteAccount() {
    try {
      const response = await apiService.delete(API_ENDPOINTS.USERS.DELETE_ACCOUNT);
      return response;
    } catch (error) {
      console.error('Fiók törlése hiba:', error);
      throw error;
    }
  }

  // Email cím megerősítése
  async verifyEmail(token) {
    try {
      const response = await apiService.post(API_ENDPOINTS.USERS.VERIFY_EMAIL, { token });
      return response;
    } catch (error) {
      console.error('Email megerősítése hiba:', error);
      throw error;
    }
  }

  // Email megerősítés újraküldése
  async resendVerificationEmail() {
    try {
      const response = await apiService.post(API_ENDPOINTS.USERS.RESEND_VERIFICATION);
      return response;
    } catch (error) {
      console.error('Email újraküldése hiba:', error);
      throw error;
    }
  }

  // Felhasználói beállítások lekérése
  async getSettings() {
    try {
      const response = await apiService.get(API_ENDPOINTS.USERS.SETTINGS);
      return response;
    } catch (error) {
      console.error('Beállítások lekérése hiba:', error);
      throw error;
    }
  }

  // Felhasználói beállítások frissítése
  async updateSettings(settings) {
    try {
      const response = await apiService.put(API_ENDPOINTS.USERS.SETTINGS, settings);
      return response;
    } catch (error) {
      console.error('Beállítások frissítése hiba:', error);
      throw error;
    }
  }
}

export default new UserService();